import Calc from "@/common/util/calculator"
import BaseFixmethod, { type FixmethodPosition } from "@/signomatic/app/fixmethods/base"
import CircleObject from "@/signomatic/app/objects/circle"
import GroupObject from "@/signomatic/app/objects/group"

export default class CustomHolesFixmethod extends BaseFixmethod {
  positions(): FixmethodPosition[] {
    const { widthPx, heightPx } = this.state

    const holeCount = this.state.customHoleCount || 2
    const distance = Calc.mmToPx(2)
    const diameter = Calc.mmToPx(this.state.customHoleSizeMm || 3)
    const radius = diameter / 2

    const positions: FixmethodPosition[] = []
    const defaults = { diameter }

    if (holeCount === 1) {
      positions.push({ ...defaults, left: widthPx / 2 + radius, top: distance + radius })
    } else if (holeCount === 2) {
      positions.push({ ...defaults, left: distance + radius, top: heightPx / 2 })
      positions.push({ ...defaults, left: widthPx - distance - radius, top: heightPx / 2 })
    } else if (holeCount === 4) {
      const left = distance + radius
      const top = distance + radius
      const right = widthPx - distance - radius
      const bottom = heightPx - distance - radius
      positions.push({ ...defaults, left: left, top: top })
      positions.push({ ...defaults, left: left, top: bottom })
      positions.push({ ...defaults, left: right, top: top })
      positions.push({ ...defaults, left: right, top: bottom })
    }

    return positions
  }

  private buildDrawable(holeStroke: string, holeFill: string, outerWidth: number) {
    const { widthPx, heightPx } = this.state
    const items: fabric.Object[] = []
    const positions = this.positions()

    if (positions.length === 1 && positions[0].left && positions[0].top && positions[0].diameter) {
      const holeRadius = positions[0].diameter / 2
      const left = positions[0].left
      const top = positions[0].top

      items.push(
        new CircleObject({
          radius: holeRadius,
          left,
          top,
          stroke: holeStroke,
          strokeWidth: outerWidth,
          startAngle: 0,
          endAngle: Calc.toDeg(Math.PI * 2),
          fill: holeFill,
        }).addClass("hang", "custom_holes")
      )

      // stretch out
      items.push(
        new CircleObject({
          radius: holeRadius,
          left,
          top: heightPx - top,
          startAngle: 0,
          endAngle: Calc.toDeg(Math.PI * 2),
          stroke: "transparent",
          strokeWidth: outerWidth,
          fill: "transparent",
        })
      )
    } else {
      for (const e of positions) {
        items.push(
          new CircleObject({
            left: e.left || 0,
            top: e.top || 0,
            radius: (e.diameter || 0) / 2,
            stroke: holeStroke,
            strokeWidth: outerWidth,
            fill: holeFill,
          }).addClass("hang", "custom_holes")
        )
      }
    }

    return [
      new GroupObject(items, {
        left: 0,
        top: 0,
        width: widthPx,
        height: heightPx,
      }),
    ]
  }

  topDrawable() {
    return this.buildDrawable("#aaa", "#F5F7F6", 1 / this.drawables.scale)
  }

  engravingDrawable() {
    return this.buildDrawable(this.drawables.engravingColor, "transparent", this.drawables.engravingStrokeWidth)
  }
}
